import { render, staticRenderFns } from "./S3CostTab.vue?vue&type=template&id=df12807e&scoped=true"
import script from "./S3CostTab.vue?vue&type=script&lang=js"
export * from "./S3CostTab.vue?vue&type=script&lang=js"
import style0 from "./S3CostTab.vue?vue&type=style&index=0&id=df12807e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df12807e",
  null
  
)

export default component.exports